import React, { memo, useEffect } from 'react';
import { Filters } from '@one-thd/sui-icons';

export interface FilterTriggerButtonProps {
  onClick: () => void;
  activeCount?: number;
  /** Whether the filter drawer this button opens is currently open; reflected as aria-expanded. */
  isOpen?: boolean;
}

const FilterTriggerButtonComponent: React.FC<FilterTriggerButtonProps> = memo(
  ({ onClick, activeCount = 0, isOpen = false }: FilterTriggerButtonProps) => {
    useEffect(() => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('filter-trigger-button.ready');
    }, []);

    return (
      <button
        type="button"
        onClick={onClick}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        className="sui-inline-flex sui-h-9 sui-items-center sui-gap-2 sui-whitespace-nowrap sui-rounded-base sui-border-1 sui-border-solid sui-border-strong sui-px-3 sui-text-sm hover:sui-bg-subtle"
      >
        <Filters size="small" />
        {activeCount > 0 ? `Filter (${activeCount})` : 'Filter'}
      </button>
    );
  }
);

FilterTriggerButtonComponent.displayName = 'FilterTriggerButton';

const FilterTriggerButton = FilterTriggerButtonComponent;

export { FilterTriggerButton };
